import {
  FULL_FLIGHT_TIER_2,
  COLLINS_PHM_TIER_3,
  COLLINS_PHM_TIER_4,
} from '@/utilities/appConsts'

const getCurrentRoutePath = router => {
  return router.currentRoute.path
}

const buildLinks = (parentPath, routes, currentRoutePath) => {
  if (routes) {
    const links = routes
      .filter(route =>
        route
          ? route.display && route.meta && route.meta.primaryNavigation
          : false,
      )
      .map(route => {
        const toPath =
          parentPath !== '' ? `${parentPath}/${route.path}` : route.path
        return {
          ...route,
          title: route.name,
          to: toPath,
          links: buildLinks(route.path, route.children, currentRoutePath),
        }
      })
    return links
  }
}

export const getPrimaryL1Links = router => {
  if (router) {
    const routes = router.options.maps
      ? router.options.maps
      : router.options.routes
    const currentRoutePath = getCurrentRoutePath(router)
    const updatedLinks = buildLinks('', routes, currentRoutePath)
    return updatedLinks
  }

  return []
}

export const getPrimaryL2Links = (router, index) => {
  const routes = []
  routes.push(router.options.routes[index])
  const currentRoutePath = getCurrentRoutePath(router)
  const currentRouteLinks = buildLinks('', routes, currentRoutePath)
  const updatedLinks = []
  const [parentLink] = currentRouteLinks
  updatedLinks.push({
    ...parentLink,
    index: '',
    isL2Parent: true,
  })
  const childLinks = parentLink.children.map(item => {
    return {
      ...item,
      isL2Child: true,
    }
  })
  updatedLinks.push(...childLinks)

  return updatedLinks
}

export const getSecondaryLinks = router => {
  const routes = router.options.routes
  const currentRoutePath = getCurrentRoutePath(router)
  const updatedLinks = buildLinks('', routes, currentRoutePath)
  if (updatedLinks.length > 0) {
    const filteredLinks = updatedLinks.filter(item => item.isActive)
    return filteredLinks.length > 0 ? filteredLinks[0].links : []
  }
  return []
}
const hasAnserToolPermissions = userAirlines => {
  return userAirlines.some(airline => {
    return [FULL_FLIGHT_TIER_2, COLLINS_PHM_TIER_3, COLLINS_PHM_TIER_4].some(
      tierId => airline.phmAgreementTypes.includes(tierId),
    )
  })
}

const isRouteAvailable = (route, hasRole, userAirlines) => {
  if (!route.meta || !route.meta.requiresRole) {
    return route.display
  }

  const requiredRoles = Array.isArray(route.meta.requiresRole)
    ? route.meta.requiresRole
    : [route.meta.requiresRole]

  for (const role of requiredRoles) {
    // If the AnserUser role then check for tiers
    if (role.name === 'AnserUser') {
      return (
        hasRole(role.name) &&
        userAirlines.length &&
        hasAnserToolPermissions(userAirlines)
      )
    }
    if (hasRole(role.name)) {
      return route.display
    }
  }

  return false
}

export const updateRouterRoutesGivenPermissions = (
  router,
  hasRole,
  userAirlines,
  isMxRecReadPermission,
  isFaultCodeManagementPermission,
) => {
  const updateRoutes = routes => {
    return routes.map(route => {
      let displayRoute = isRouteAvailable(route, hasRole, userAirlines)

      if (route.children && route.children.length > 0) {
        route.children = updateRoutes(route.children)

        // If any child route is displayed, display the parent route as well
        const hasDisplayedChild = route.children.some(child => child.display)
        displayRoute = displayRoute || hasDisplayedChild
      }

      if (route.path === '/maintenance') {
        displayRoute = displayRoute && isMxRecReadPermission
      }
      if (route.path === '/maintenance') {
        displayRoute = isMxRecReadPermission
      }

      if (route.path === '/v3/fleet-management') {
        displayRoute = isFaultCodeManagementPermission
      }

      return {
        ...route,
        display: displayRoute,
      }
    })
  }

  return updateRoutes(router.options.routes)
}
